import axios from "axios";
import { showCustomToast } from "./toastUtil";

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    const userObj = localStorage.getItem("salla_discourse_user");
    if (userObj) {
      const user = JSON.parse(userObj);
      config.headers["Api-Username"] = user?.id;
      config.headers["Api-Key"] = user?.api_key;
    }
    config.headers["Content-Type"] = "multipart/form-data";

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 401)
    ) {
      const errorMessage = error.response.data?.errors?.[0];
      const userObj = localStorage.getItem("salla_discourse_user");
      const user = JSON.parse(userObj);
      if (
        errorMessage === "Your session has expired." ||
        errorMessage ===
          "You are not permitted to view the requested resource. The API username or key is invalid." ||
        errorMessage === "You need to be logged in to do that." ||
        user?.api_key === null
      ) {
        localStorage.removeItem("salla_discourse_user");
        window.location.href =
          process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
      } else {
        showCustomToast(
          "حدث خطأ من الخادم (قد تؤدي إعادة تسجيل الدخول إلى حل المشكلة)",
          "error"
        );
      }
    }
    return Promise.reject(error);
  }
);
